module.exports = __webpack_public_path__ + "img/layout_form_icon.a7f4b528.svg";